(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7834],{

/***/ 94357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country.json
var bank_country = __webpack_require__(55881);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/open-bank-account/index.js + 1 modules
var open_bank_account = __webpack_require__(53001);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/marshall-islands/open-bank-account/data.json
var data_namespaceObject = JSON.parse('{"country":"Marshall Islands","imgAlt":"open a bank account for Marshall Islands company","breadcrumbs":[{"title":"Company Formation","uri":"/company-formation"},{"title":"Marshall Islands","uri":"/company-formation/marshall-islands"},{"title":"Open bank account","uri":"/company-formation/marshall-islands/open-bank-account"}],"dataPageType":[{"title":"Company Formation","uri":"/company-formation/marshall-islands"},{"title":"Open Bank Account","uri":"/company-formation/marshall-islands/open-bank-account"},{"title":"Other Services","uri":"/company-formation/marshall-islands/other-services"}],"dataHowToOpen":{"title":"How to open bank account for<br/>Marshall Islands company","content":["<p>One initial step to start your offshore business venture is to apply for a ​business bank account. This allows business owners to keep their business depositing and expenditure separate from personal accounts, meaning better limited liability protection and enhanced credibility for your business. As for Marshall Islands company, there are common application choices to open your business account:</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Applying in a local bank in Marshall Islands:</h3>","<p>The Republic of Marshall Islands (RMI) is a Micronesian nation located in the middle of the Pacific Ocean. The country uses the United States dollar as local currency and doesn’t have its own monetary authority. RMI depends heavily on US financial aids, which approximates 20% annual GDP.</p>","<p>RMI banking sector is made up of only 3 commercial banks including one domestic financial institution - The Bank of Marshall Islands (BOMI), two foreign-owned banks: The First Hawaiian Bank (FHB), a subsidiary of BNP Paribas and The Bank of Guam.</p>","<p>Only two foreign-owned banks have access to the international financial market to facilitate their banking services. The BOMI has to lean on its only correspondent banking relationship with FHB to execute cross-border transactions. This longstanding relationship is now threatened to put to an end.</p>","<p>Marshall Islands is facing a huge risk of being isolated from the international financial market as the lack of supervisory capacity of local authorities and poor implementation of the anti-money laundering and combatting financing of terrorism framework.</p>","<h3 class=\'font-medium text-bbc-brand-700\'>Going for offshore bank accounts or fintech solutions</h3>","<p>There is no obligation for opening a Marshall Islands bank account for incorporated companies in this country. BBCIncorp can help you with offshore bank account for Marshall Islands!</p>"]},"dataRequiredDocument":{"note":"","button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"We work with top-banking partners and provide various options to open an offshore bank account for Marshall Islands company. Different banks might have unique document requirements; however, some of the most commonly asked documents can be found below:","listContent":[{"text":"Account application forms","content":[]},{"text":"Bank statements","content":[]},{"text":"Bank reference letter","content":[]},{"text":"Certified copies of passports, address proofs for all directors/shareholders","content":[]},{"text":"Business plan","content":[]},{"text":"Business proofs (sales/purchase orders, invoice, contract…)","content":[]},{"text":"Government certification of company good standing status.","content":[]},{"text":"You had better contact BBCIncorp to know the exact documents needed for your case.","content":[]}]},{"title":"You had better contact BBCIncorp to know the exact documents needed for your case."}]}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/marshall-islands/open-bank-account/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(open_bank_account/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject,
      dataBank: {
        traditional: bank_country/* marshall_islands */.q8,
        emi: bank_emis/* marshall_islands */.q8
      }
    })
  });
}

/***/ }),

/***/ 11692:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/marshall-islands/open-bank-account",
      function () {
        return __webpack_require__(94357);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,5955,9131,4090,9738,7447,2864,58,5881,5999,6618,2888,179], function() { return __webpack_exec__(11692); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);